var React = require('react');

function House (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.70859 16.3274V11.3274H11.7086V16.3274C11.7086 16.8774 12.1586 17.3274 12.7086 17.3274H15.7086C16.2586 17.3274 16.7086 16.8774 16.7086 16.3274V9.32736H18.4086C18.8686 9.32736 19.0886 8.75736 18.7386 8.45736L10.3786 0.927363C9.99859 0.587363 9.41859 0.587363 9.03859 0.927363L0.678594 8.45736C0.338594 8.75736 0.548594 9.32736 1.00859 9.32736H2.70859V16.3274C2.70859 16.8774 3.15859 17.3274 3.70859 17.3274H6.70859C7.25859 17.3274 7.70859 16.8774 7.70859 16.3274Z","fill":"#2F7444"}));
}

House.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = House;

House.default = House;
